export default __webpack_public_path__ + "static/media/10.e3d2f310.jpg";